import {Component, Inject, OnInit} from '@angular/core';
import {needConfirmation} from "../../../../../confirm-dialog/confirm-dialog.decorator";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {Subscription} from "rxjs";
import {ListType} from "../../../../../components/types/types.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {LogService} from "../../../../../services/log.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-add-report-card-type',
  templateUrl: './add-report-card-type.component.html',
  styleUrls: ['./add-report-card-type.component.scss']
})
export class AddReportCardTypeComponent implements OnInit {
  selectedType = '';
  types: Array<ListType> = [];
  fieldForm!: FormGroup
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private mDatabase : AngularFireDatabase,
              private mLogService : LogService,
              private matDialog :MatDialog,
              private fb: FormBuilder) { }

  ngOnInit(): void {
    this.selectedType = this.data;
    this.fieldForm = this.fb.group({
      field: ['', Validators.required]
    });
  }
  @needConfirmation()
  AddTypData() {
    console.log(this.data)
    const key = this.mDatabase.database.ref('types/' + this.selectedType).push().key
    if (this.fieldForm.valid) {
      const field = this.fieldForm.get('field')?.value
      this.mDatabase.object('types/' + this.selectedType + "/" + key).set(field).then(() => {
        this.fieldForm?.reset()
        this.matDialog.closeAll()
        let activity = {
          date: new Date().getTime(),
          section: 'Types',
          action: 'Submit',
          description: `Types Submit  ${field} Master by user`,
          currentIp: localStorage.getItem('currentip')!
        }
        this.mLogService.addLog(activity)
      })
    } else alert('Please Enter Form')
// alert(this.field)
  }


}
